
export const BaseBillingUrl = '/billings';
export const BillingsUrl = `${BaseBillingUrl}`;
export const NewBillingUrl = `${BaseBillingUrl}/new`;